/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { Channel, ChannelEntityDef, EntityDef } from '../../common/types/types';

interface InvokeChannelActionMutationProps {
    actionName: string;
    args: object;
    channel: Channel;
    channelDefId?: object;
    channelEntityDef?: ChannelEntityDef;
    connectedChannel?: object;
    entityDef?: EntityDef;
    keys?: unknown[];
}

export default class InvokeChannelActionMutation extends Relay.Mutation<InvokeChannelActionMutationProps> {

    static propTypes = {
        actionName: PropTypes.string.isRequired,
        args: PropTypes.object.isRequired,
        channel: PropTypes.object.isRequired,
        channelDefId: PropTypes.object,
        channelEntityDef: PropTypes.object,
        connectedChannel: PropTypes.object,
        entityDef: PropTypes.object,
        keys: PropTypes.array,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Channel {
                    organisation_id,
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {invokeChannelAction}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on InvokeChannelActionPayload {
                success,
                message,
                response
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            channel_id: this.props.channel.id,

            channelDef_id: this.props.channelDefId ? this.props.channelDefId : null,
            channelEntityDef_id: this.props.channelEntityDefId ? this.props.channelEntityDefId : null,

            entityDef_id: this.props.entityDef ? this.props.entityDef.id : null,
            organisation_id: this.props.channel.organisation_id,
            connectedChannel_id: this.props.connectedChannel ? this.props.connectedChannel.id : null,
            actionName: this.props.actionName,
            args: JSON.stringify(this.props.args),
        };
    }
}
